import { render, staticRenderFns } from "./amz_stkchk.vue?vue&type=template&id=39edf794&scoped=true&"
import script from "./amz_stkchk.vue?vue&type=script&lang=js&"
export * from "./amz_stkchk.vue?vue&type=script&lang=js&"
import style0 from "./amz_stkchk.vue?vue&type=style&index=0&id=39edf794&scoped=true&lang=less&"
import style1 from "./amz_stkchk.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39edf794",
  null
  
)

export default component.exports